import { render } from "./billing-details.vue?vue&type=template&id=521af14a&scoped=true"
import script from "./billing-details.vue?vue&type=script&lang=js"
export * from "./billing-details.vue?vue&type=script&lang=js"

import "./billing-details.vue?vue&type=style&index=0&id=521af14a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521af14a"]])

export default __exports__